import { Grid, Typography } from "@mui/material";
import styles from "./About.module.css";
import about_us_image from '../../Images/About/background.jpg';
import ProcessCard from "./ProcessCard";
const About =() =>{
    return(     
        <Grid container className={styles.main_container}>
            <Grid container item className={styles.main_image_container} xs={12}>
                <img className={styles.main_image_container} src={about_us_image} loading="lazy"/>
            </Grid>
            <div className={styles.about_main_line}></div>

            <Grid container item className={styles.main_process_container}>
                <Grid xs ={12}><ProcessCard direction={'right'}/></Grid>
                <Grid xs ={12}><ProcessCard direction={'left'}/></Grid>
                <Grid xs ={12}><ProcessCard direction={'right'}/></Grid>
                <Grid xs ={12}><ProcessCard direction={'left'}/></Grid>
                <Grid xs ={12}><ProcessCard direction={'right'}/></Grid>
                <Grid xs ={12}><ProcessCard direction={'left'}/></Grid>
                <Grid xs ={12}><ProcessCard direction={'right'}/></Grid>
                <Grid xs ={12}><ProcessCard direction={'left'}/></Grid>
                <Grid xs ={12}><ProcessCard direction={'right'}/></Grid>
                <Grid xs ={12}><ProcessCard direction={'left'}/></Grid>
            </Grid>
        </Grid>
    )
}

export default About;